import type {
  SchoolCandidateListExportRequest,
  SchoolCandidateNewResidencesRequest,
} from "../../../queries";
import {
  useDownloadSchoolCandidateResidencesMutation,
  useGetSchoolCandidateListExportMutation,
  useLazyGetSchoolCandidateNewResidencesQuery,
  useSaveInstitutionAssignmentMutation,
  useSetInstitutionAssignmentMutation,
  useStartSchoolCandidateBatchMutation,
} from "../../../queries";
import { useAuthCounties } from "../../../hooks";

export const useSchoolCandidateAddressAccess = () => {
  const authCounties = useAuthCounties();

  const [
    triggerGetSchoolCandidateNewResidences,
    {
      data: schoolCandidateNewResidences,
      isFetching: isSchoolCandidateNewResidencesFetching,
    },
  ] = useLazyGetSchoolCandidateNewResidencesQuery();

  const [startSchoolCandidateBatchRequest] =
    useStartSchoolCandidateBatchMutation();
  const [saveInstitutionAssignmentRequest] =
    useSaveInstitutionAssignmentMutation();
  const [setInstitutionAssignmentRequest] =
    useSetInstitutionAssignmentMutation();
  const [triggerGetSchoolCandidateListExport] =
    useGetSchoolCandidateListExportMutation();
  const [downloadSchoolCandidateResidencesRequest] =
    useDownloadSchoolCandidateResidencesMutation();

  const handleSearchNewResidences = async (
    request: SchoolCandidateNewResidencesRequest
  ) => {
    await triggerGetSchoolCandidateNewResidences(request);
  };

  const handleGetSchoolCandidateListExport = async (
    request: SchoolCandidateListExportRequest
  ) => {
    await triggerGetSchoolCandidateListExport(request);
  };

  return {
    authCounties,
    schoolCandidateNewResidences,
    isSchoolCandidateNewResidencesFetching,
    handleSearchNewResidences,
    startSchoolCandidateBatchRequest,
    saveInstitutionAssignmentRequest,
    setInstitutionAssignmentRequest,
    handleGetSchoolCandidateListExport,
    downloadSchoolCandidateResidencesRequest,
  };
};
